
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
@Component({
  components: { Icon }
})
export default class HoverEnabler extends Vue {
  @Prop()
  hoverValuePresent!: boolean;

  @Prop()
  enabled!: boolean;

  get classes() {
    return {
      "breakdance-control-modifier-icon": true,
      "breakdance-control-modifier-icon-enabled": this.enabled,
      "breakdance-control-modifier-icon-value-present": this.hoverValuePresent
    };
  }
}
